import { RequestSecSessionRes } from 'entities/Form';
import { createContext, ReactNode, useContext, useState } from 'react';

interface SecSessionContext {
  secSession: RequestSecSessionRes | null;
  setSecSession: (secSession: RequestSecSessionRes | null) => void;
}

const SecSession = createContext<SecSessionContext | undefined>(undefined);

export const useSecSession = () => {
  const context = useContext(SecSession);
  if (!context) throw new Error('useSecSession must be used within an SecSessionProvider');
  return context;
};

export const SecSessionProvider = ({ children }: { children: ReactNode }) => {
  const [secSession, setSecSession] = useState<RequestSecSessionRes | null>(null);

  return <SecSession.Provider value={{ secSession, setSecSession }}>{children}</SecSession.Provider>;
};
